export class Subscriber {


    email: string;
    name: string;

    type: string;

    constructor() {
        this.email = null;
        this.name = null;
        this.type = 'amor';
    }

}